import {
  ButtonGroup,
  styled,
} from '@mui/material';

import { COLOR_BORDER } from '~/components/App/theme';

export const AnnotationButtonGroup = styled(ButtonGroup)((props) => {
  const { theme: { palette: { primary } } } = props;
  return (
    {
      background: primary.contrastText,
      border: `1px solid ${COLOR_BORDER}`,
      borderRadius: '4px',
      button: {
        padding: '18px',
        margin: '4px',
      },
    }
  );
})
